import { useState, useEffect, useRef, MutableRefObject } from 'react';

const useIsMounted = <T extends HTMLElement>() => {
  const [element, setElememt] = useState<T | null>();

  const parentRef = useRef<T>(null);

  useEffect(() => {
    setElememt(parentRef?.current);
  }, []);
  return [parentRef, element] as [MutableRefObject<T>, T | undefined];
};
export default useIsMounted;
